export enum ExportType {
  CLEAR_VAULT_SUMMARY = 'clear_vault_summary',
  LIQUIDATION_LETTER = 'liquidation_letter',
  CLEAR_ESTATE_SUMMARY = 'clear_estate_summary',
  CLEAR_VAULT_FINAL_REPORT = 'clear_vault_final_report',
  EXECUTOR_RESIDUAL_BENEFICIARIES_DISTRIBUTION_PLAN = 'executor_residual_beneficiaries_distribution_plan',
  FINAL_TAXES_SUMMARY = 'final_taxes_summary',
  SPECIFIC_BENEFICIARY_DISTRIBUTION_PLAN = 'specific_beneficiary_distribution_plan',
  BENEFICIARY_FINANCIAL_INFORMATION = 'beneficiary_financial_information',
  PURCHASE_SUMMARY = 'purchase_summary',
  NOTIFY_CREDITORS_INSTRUCTIONS = 'notify_creditors_instructions',
  CALIFORNIA_NOTIFY_BENEFICIARIES_INSTRUCTIONS = 'california_notify_beneficiaries_instructions',
  WILLS_NOTICE_SEARCH_INSTRUCTIONS = 'wills_notice_search_instructions',
  DIAGNOSTIC_TOOL_RESULTS_PAGE = 'diagnostic_tool_results_page',
  CAIN_LAMARRE_RECEIPTS_SUMMARY = 'cain_lamarre_receipts_summary'
}
